import i18next from "i18next";

import { createColumn } from "../../../../components/Table";

/**
 * EN-5078: wards with EnablePatientAddMedication let patients manage their own
 * medications in the app, so the acceptance workflow and structured dosage don't
 * apply — those columns are hidden for these patients. Their medications carry a
 * structured schedule instead, so a Time column (the dose times, e.g.
 * "12:00pm, 2:00pm") is shown after Schedule.
 */
export function buildDesktopTableColumns(patientAddMedication: boolean) {
  return [
    createColumn({
      keyName: "name",
      header: () => i18next.t("patientPage_columns_name"),
      cell: (info) => info.renderValue(),
      size: 200,
    }),
    ...(patientAddMedication
      ? []
      : [
          createColumn({
            keyName: "status",
            header: () => i18next.t("patientPage_columns_accepted_medication"),
            cell: (info) => info.renderValue(),
            size: 80,
          }),
          createColumn({
            keyName: "dosage",
            header: () => i18next.t("patientPage_columns_dosage"),
            cell: (info) => info.renderValue(),
            size: 80,
          }),
        ]),
    createColumn({
      keyName: "frequency",
      header: () => i18next.t("patientPage_columns_schedule"),
      cell: (info) => info.renderValue(),
      size: 80,
    }),
    ...(patientAddMedication
      ? [
          createColumn({
            keyName: "times",
            header: () => i18next.t("patientPage_columns_time"),
            cell: (info) => info.renderValue(),
            size: 100,
          }),
        ]
      : []),
    createColumn({
      keyName: "route",
      header: () => i18next.t("patientPage_columns_route"),
      cell: (info) => info.renderValue(),
      size: 80,
    }),
    createColumn({
      keyName: "source",
      header: () => i18next.t("patientPage_columns_source"),
      cell: (info) => info.renderValue(),
      size: 80,
    }),
  ];
}
